module.exports = __webpack_public_path__ + "media/images/clients/manual-acf8dda353f180dd4d2a7bc5b87f8bfb.svg";